<template>
  <section class="container-fluid section-hero ">
    <div class="row landing">
        <div class="hero col-12 col-lg-12 d-flex flex-column align-items-center justify-content-center">
            <div class="fullstack mb-4">
                Desarrollador Full-Stack
            </div>
            <h1 class="text-center" id="yosoy">Soy Andrés</h1>
            <p id="description" class="text-lg-start text-center">Diseño y codifico varias aplicaciones de software, sitios web y otras soluciones digitales.. </p>
            
            <a href="#contact" class="contact-me mt-5"> CONTÁCTAME!</a>
        </div>
        
    </div>
</section>

<ul class="circles">
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
    <li></li>
</ul>
</template>

<script>

export default {
    name: "LandingPage",
}
</script>

<style>

</style>